<p class="mat-caption label {{ labelColor }}" [class.no-bottom-margin]="inline">
  <span class="label-data">
    {{ labelValue | locLabel | capitalize }}
  </span>
  <br *ngIf="twoLine" />
  <span
    [ngClass]="{ 'mat-error': error, 'mat-black': !error && !highlighted, 'mat-primary': !error && highlighted, space: !twoLine }"
  >
    <ng-content></ng-content>
  </span>
</p>
